import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
const appendixVariants = cva('node-appendix absolute flex w-full flex-col items-center rounded-md border bg-card p-1 text-card-foreground', {
  variants: {
    position: {
      top: '-my-1 -translate-y-full',
      bottom: 'top-full my-1',
      left: '-left-full -mx-1',
      right: 'left-full mx-1'
    }
  },
  defaultVariants: {
    position: 'top'
  }
});
export interface NodeAppendixProps extends ComponentProps<'div'>, VariantProps<typeof appendixVariants> {
  className?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}
export function NodeAppendix(t0) {
  const $ = _c(12);
  let children;
  let className;
  let position;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      position,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = position;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    position = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== position) {
    t1 = cn(appendixVariants({
      position
    }), className);
    $[5] = className;
    $[6] = position;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}